module.exports = require("../export-contract.js")(require("../patterns/de-1996.js"));